"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.appWithOrigin = exports.OriginProvider = exports.useOrigin = exports.deserializeOrigin = exports.createOriginProp = exports.getOriginPageProp = exports.ORIGIN_PROP = void 0;
const hoist_non_react_statics_1 = __importDefault(require("hoist-non-react-statics"));
const get_1 = __importDefault(require("lodash/get"));
const react_1 = __importStar(require("react"));
exports.ORIGIN_PROP = '_o';
function getOriginPageProp(props) {
    return (0, get_1.default)(props, ['pageProps', exports.ORIGIN_PROP], (0, get_1.default)(props, [exports.ORIGIN_PROP]));
}
exports.getOriginPageProp = getOriginPageProp;
const ORIGIN_VALIDATION_REGEX = new RegExp('^https?://[^/]+$');
class InvalidOrigin extends Error {
    constructor(origin) {
        super(`Origin is invalid: "${origin}"`);
    }
}
function validateOrigin(origin) {
    if (!ORIGIN_VALIDATION_REGEX.test(origin)) {
        throw new InvalidOrigin(origin);
    }
}
function createOriginProp(origin) {
    validateOrigin(origin);
    return {
        [exports.ORIGIN_PROP]: origin,
    };
}
exports.createOriginProp = createOriginProp;
function deserializeOrigin(origin) {
    validateOrigin(origin);
    const { protocol, host: domain } = new URL(origin);
    return { protocol, origin, domain };
}
exports.deserializeOrigin = deserializeOrigin;
const OriginCtx = react_1.default.createContext({
    protocol: 'https',
    domain: '',
    origin: 'https://',
});
function useOrigin() {
    return (0, react_1.useContext)(OriginCtx);
}
exports.useOrigin = useOrigin;
exports.OriginProvider = OriginCtx.Provider;
function appWithOrigin(WrappedAppComponent) {
    function AppWithObjectId(props) {
        const origin = getOriginPageProp(props.pageProps);
        const ctx = (0, react_1.useMemo)(() => deserializeOrigin(origin), [origin]);
        return (react_1.default.createElement(exports.OriginProvider, { value: ctx },
            react_1.default.createElement(WrappedAppComponent, Object.assign({}, props))));
    }
    return (0, hoist_non_react_statics_1.default)(AppWithObjectId, WrappedAppComponent);
}
exports.appWithOrigin = appWithOrigin;
//# sourceMappingURL=index.js.map